export const HexIcon = ({ children, size = 64, dark = false }) => (
  <div className="relative shrink-0" style={{ width: size, height: size }}>
    <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full">
      <polygon
        points="50,3 93,26 93,74 50,97 7,74 7,26"
        fill={dark ? "rgba(229,169,60,0.12)" : "rgba(200,145,47,0.10)"}
        stroke={dark ? "rgba(229,169,60,0.7)" : "#C8912F"}
        strokeWidth="2"
      />
    </svg>
    <div className={`absolute inset-0 flex items-center justify-center ${dark ? "text-amber-400" : "text-gold-deep"}`}>
      {children}
    </div>
  </div>
);

export const HexGlyph = ({ className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <polygon
      points="50,6 90,28 90,72 50,94 10,72 10,28"
      fill="none"
      stroke="currentColor"
      strokeWidth="7"
    />
  </svg>
);
